import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';

import { configureReduxQuerySync } from '../utils/configure-redux-query-sync';
import { VideoHub } from '../components/VideoHub';

export const VideoHubProvider = ({ store, data }) => {
    useEffect(() => {
        configureReduxQuerySync(store);
    }, [store]);

    return (
        <Provider store={store}>
            <VideoHub {...data} />
        </Provider>
    );
};

export default VideoHubProvider;

VideoHubProvider.propTypes = {
    store: PropTypes.object.isRequired,
    data: PropTypes.object
};
